import React, { useEffect, useRef, useState } from 'react';
import { APP_VARIABLES } from '@constants/app-constants';
import ClevertapReact from 'src/utils/clever-tap';
import EmployeeSalariesService from 'src/services/employee-salaries-service';
import EmployeeService from 'src/services/employee-service';
import MainDashboardPresentational from './main-dashboard-presentational';
import PayoutTimingService from 'src/services/PayoutTiming-service';
import PayrollService from 'src/services/payroll-service';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import { connect, useDispatch } from 'react-redux';
import appActions from '@sharedComponent/app-action-reducer/action';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import '../main-dashboard.scss';

let TIMER_CALL = '';
const MainDashboard = ({ currentUser }) => {
	const [pageLoading, setPageLoading] = useState(true);
	let [payrollHistory, setPayrollHistory] = useState([]);
	let [employeeCount, setEmployeeCount] = useState({});
	let [payoutTiming, setPayoutTiming] = useState([]);
	let [employeePaidByMonth, setEmployeePaidByMonth] = useState([]);
	let [employeePaidByPayrollChannel, setEmployeePaidByPayrollChannel] = useState([]);
	let [cardRequest, setCardRequest] = useState([]);
	let [currentTimeCutOff, setCurrentTimeCutOff] = useState({});
	let [isDataLoading, setIsDataLoading] = useState(false);
	let [isPayrollHistoryLoading, setIsPayrollHistoryLoading] = useState(true);
	let [isCardHistoryLoading, setIsCardHistoryLoading] = useState(false);
	let [isEmployeePaidLoading, setIsEmployeePaidLoading] = useState(false);
	let [isPayrollAmountLoading, setIsPayrollAmountLoading] = useState(false);
	let [isEmployeeCountLoading, setIsEmployeeCountLoading] = useState(false);
	const [approveReqCount, setApproveReqCount] = useState();

	// Recording the screen time spent on the dashboard page for CleverTap.
	const [startTime] = useState(() => Date.now());
	let totalPayrollHistory = useRef([]);
	let totalCardRequest = useRef([]);
	let totalEmployeePaidOff = useRef([]);
	let totalPayrollAmount = useRef([]);

	const dispatch = useDispatch();

	let cardReqSlideIndex = useRef({
		startIndex: 0,
		endIndex: 2,
	});

	//Bar Chart Pagination -- Payroll Amount
	let payrollAmountSlideIndex = useRef({
		startIndex: 0,
		endIndex: 6,
	});
	const history = useHistory();
	const _payrollService = new PayrollService();
	const employeesSalaryApi = new EmployeeSalariesService();
	const payoutTimingApi = new PayoutTimingService();
	const employeeApi = new EmployeeService();
	const { user } = currentUser;

	const callRemainingAPIs = () => {
		fetchPayrollHistory();
		getDashboardDetails();
		getApproveRequestCount();
		fetchEmployeePaidMonthWise();
	};
	useEffect(() => {
		if (history.location.state && history.location.state.response) {
			window.location.reload();
		}
	}, [history?.location?.state?.response]);

	useEffect(() => {
		fetchInvoiceDetails();
	}, []);

	useEffect(() => {
		let accessToken = localStorage.getItem(APP_VARIABLES.ACCESS_TOKEN);
		if (user && accessToken) {
			fetchPendingRequests();
			return function cleanup() {
				clearTimeout(TIMER_CALL);
			};
		}
	}, [user]);

	useEffect(() => {
		return () => {
			const screenTime = (Date.now() - startTime) / 1000;
			ClevertapReact.event('Dashboard_Viewed', {screen_time: screenTime});
		}
	}, [startTime]);

	const getApproveRequestCount = () => {
		_payrollService
			.getApproveRequestCountAPI()
			.then((res) => {
				setApproveReqCount(res && res.data && res.data.pendingRequest ? res.data.pendingRequest : null);
			})
			.catch((error) => {
				console.log(error);
			});
	};


	async function getDashboardDetails() {
		let [
			payoutTimingResponse,
			employeePaidByPayrollResp,
		] = await Promise.all([
			fetchPayoutTiming(),
			fetchEmployeePaidByPayrollChannel(),
			fetchEmployeeCount(),
		]);

		if (payoutTimingResponse) {
			let time = new Date().toLocaleTimeString();
			let currentTimeInfo = payoutTimingResponse.payoutTimings.find((timing) => {
				let startTime = moment(timing.startTime, 'h:mm a');
				let endTime = moment(timing.endTime, 'h:mm a');
				let currentTime = moment(time, 'h:mm a');
				return currentTime.isBetween(startTime, endTime, 'time');
			});
			if (currentTimeInfo) {
				setCurrentTimeCutOff(currentTimeInfo);
				setPayoutTiming([
					{
						title: 'WPS Cut Off',
						time: currentTimeInfo.bankWPS,
					},
					{
						title: 'Non WPS Cut Off',
						time: currentTimeInfo.bankNonWPS,
					},
				]);
			}
		}

		if (employeePaidByPayrollResp) {
			let updated = employeePaidByPayrollResp.salaryPayrollChannel.map((salaryPayrollChannel) => {
				salaryPayrollChannel.month = moment(salaryPayrollChannel.month, 'MMM YYYY').format('MMM YY');
				return salaryPayrollChannel;
			});
			setEmployeePaidByPayrollChannel(updated.slice(-6));
			if (updated.length <= 6) {
				setCurrentPayrollAmountActiveSlide({
					prev: false,
					next: false,
				});
			} else {
				payrollAmountSlideIndex.current.endIndex = updated.length;
				payrollAmountSlideIndex.current.startIndex = updated.length - 6;
				setCurrentPayrollAmountActiveSlide({
					prev: true,
					next: false,
				});
			}
			totalPayrollAmount.current = [...updated];
		}
		setIsDataLoading(false);
	}

	async function fetchPendingRequests() {
		setIsCardHistoryLoading(true);
		try {
			let fetchPendingRequestsResponse = await employeeApi.getCardStatus();
			if (fetchPendingRequestsResponse && fetchPendingRequestsResponse.data) {
				setIsCardHistoryLoading(false);
				let response =
					fetchPendingRequestsResponse.data.requests &&
					fetchPendingRequestsResponse.data.requests.map((request) => {
						request.noOfCards = request.numberOfRequest;
						let orderPlacedDate = moment(request.orderPlaced);
						request.orderPlaced = `${orderPlacedDate.format('DD MMMM YYYY')} at ${orderPlacedDate.format('h:mm a')}`;
						return request;
					});
				totalCardRequest.current = [...response];
				setCardRequest(response.slice(0, 10));
			} else {
				setCardRequest([]);
			}
			callRemainingAPIs();
			setPageLoading(false);
		} catch (err) {
			setIsCardHistoryLoading(false);
			setPageLoading(false);
			console.log(err);
		}
	}

	async function fetchEmployeePaidMonthWise() {
		setIsEmployeePaidLoading(true);
		try {
			let employeePaidByMonthResponse = await employeesSalaryApi.getEmployeePaidMonthWise();
			if (employeePaidByMonthResponse && employeePaidByMonthResponse.data) {
				setIsEmployeePaidLoading(false);
				let updated = employeePaidByMonthResponse.data.salaryPaidCount.map((salaryPaid) => {
					let month_year = salaryPaid.month.split(' ');
					salaryPaid.month = moment(month_year[0], 'MMM').format('MMMM');
					salaryPaid.year = month_year[1];
					return salaryPaid;
				});
				setEmployeePaidByMonth(updated.slice(0, 4));
				totalEmployeePaidOff.current = [...updated];
			}
		} catch (err) {
			console.log(err);
			setIsEmployeePaidLoading(false);
		}
	}

	async function fetchInvoiceDetails() {
		dispatch(appActions.creators.getInvoiceInfoStart());
		try {
			let response = await employeeApi.getInvoiceDetails();
			if (response && response.data) {
				dispatch(appActions.creators.getInvoiceInfoSuccess(response.data));
				return response.data;
			}
		} catch (err) {
			dispatch(appActions.creators.getInvoiceInfoFail());
		}
	}

	async function fetchEmployeePaidByPayrollChannel() {
		setIsPayrollAmountLoading(true);
		try {
			let response = await employeesSalaryApi.getEmployeePaidByPayrollChannel();
			if (response && response.data) {
				setIsPayrollAmountLoading(false);
				return response.data;
			}
		} catch (err) {
			console.log(err);
			setIsPayrollAmountLoading(false);
		}
	}

	async function fetchPayrollHistory() {
		setIsPayrollHistoryLoading(true);
		try {
			let payrollResponse = await employeesSalaryApi.getPayrollHistory(1, 10);
			if (payrollResponse && payrollResponse.data) {
				setIsPayrollHistoryLoading(false);
				if (payrollResponse.data.payrollHistory.length <= 2) {
					setCurrentActiveSlide({
						prev: false,
						next: false,
					});
				}
				let response = payrollResponse.data.payrollHistory;
				totalPayrollHistory.current = [...response];
				setPayrollHistory(response.slice(0, 10));
			}
		} catch (err) {
			console.log(err);
			setIsPayrollHistoryLoading(false);
		}
	}

	async function fetchEmployeeCount() {
		setIsEmployeeCountLoading(true);
		try {
			let response = await employeeApi.getDashboardEmployeeCount();
			if (response && response.data) {
				setIsEmployeeCountLoading(false);
				if (response.data) {
					setEmployeeCount(response.data.employeeCount);
				}
				return response.data;
			}
		} catch (err) {
			setIsEmployeeCountLoading(false);
		}
	}

	async function fetchPayoutTiming() {
		try {
			let response = await payoutTimingApi.getPayoutTiming();
			if (response && response.data) {
				return response.data;
			}
		} catch (err) {
			console.log(err);
		}
	}

	const [currentActiveSlide, setCurrentActiveSlide] = useState({
		prev: false,
		next: true,
	});
	const [currentCardOrderActiveSlide, setCurrentCardOrderActiveSlide] = useState({
		prev: false,
		next: true,
	});

	const [currentPayrollAmountActiveSlide, setCurrentPayrollAmountActiveSlide] = useState({
		prev: false,
		next: true,
	});

	function setCardHistorySliderData() {
		let { startIndex, endIndex } = cardReqSlideIndex.current;
		setCardRequest(totalCardRequest.current.slice(startIndex, endIndex));
	}

	function handleCardHistorySlideChange(navigation) {
		let { startIndex, endIndex } = cardReqSlideIndex.current;
		let totalData = totalCardRequest.current.length;
		if (!totalData) {
			return;
		}
		if (navigation === 'prev') {
			if (startIndex < 1) {
				cardReqSlideIndex.current.endIndex = totalData || 2;
				cardReqSlideIndex.current.startIndex = totalData - 2 || 0;
			} else if (startIndex === 1) {
				cardReqSlideIndex.current.endIndex = 2;
				cardReqSlideIndex.current.startIndex = 0;
			} else {
				cardReqSlideIndex.current.startIndex = endIndex - 4 ? endIndex - 4 : 0 || 0;
				cardReqSlideIndex.current.endIndex = endIndex - 2 || 2;
			}
		} else {
			if (totalData > 2 && totalData > cardReqSlideIndex.current.endIndex) {
				cardReqSlideIndex.current.startIndex = endIndex;
				cardReqSlideIndex.current.endIndex = endIndex + 2 <= totalData ? endIndex + 2 : totalData;
			} else {
				cardReqSlideIndex.current.startIndex = 0;
				cardReqSlideIndex.current.endIndex = 2;
			}
		}
		if (totalData <= cardReqSlideIndex.current.endIndex) {
			setCurrentCardOrderActiveSlide({
				prev: true,
				next: false,
			});
		} else if (totalData > 0 && cardReqSlideIndex.current.endIndex <= 2) {
			setCurrentCardOrderActiveSlide({
				prev: false,
				next: true,
			});
		} else {
			setCurrentCardOrderActiveSlide({
				prev: true,
				next: true,
			});
		}

		setCardHistorySliderData();
	}

	function handlePayrollAmountSlideChange(navigation) {
		let { startIndex, endIndex } = payrollAmountSlideIndex.current;
		let totalData = totalPayrollAmount.current.length;
		if (!totalData) {
			return;
		}
		if (navigation === 'prev') {
			if (startIndex <= 1) {
				payrollAmountSlideIndex.current.endIndex = totalData;
				payrollAmountSlideIndex.current.startIndex = totalData - 6;
			} else {
				payrollAmountSlideIndex.current.startIndex = endIndex - 12;
				payrollAmountSlideIndex.current.endIndex = endIndex - 6;
			}
		} else {
			if (totalData > 6 && totalData > payrollAmountSlideIndex.current.endIndex) {
				payrollAmountSlideIndex.current.startIndex = endIndex;
				payrollAmountSlideIndex.current.endIndex = endIndex + 6 <= totalData ? endIndex + 6 : totalData;
			} else {
				payrollAmountSlideIndex.current.startIndex = 0;
				payrollAmountSlideIndex.current.endIndex = 6;
			}
		}
		if (totalData <= payrollAmountSlideIndex.current.endIndex) {
			setCurrentPayrollAmountActiveSlide({
				prev: true,
				next: false,
			});
		} else if (totalData > 0 && payrollAmountSlideIndex.current.endIndex <= 6) {
			setCurrentPayrollAmountActiveSlide({
				prev: false,
				next: true,
			});
		} else {
			setCurrentPayrollAmountActiveSlide({
				prev: true,
				next: true,
			});
		}
		setPayrollAmountSliderData();
	}

	function setPayrollAmountSliderData() {
		let { startIndex, endIndex } = payrollAmountSlideIndex.current;
		setEmployeePaidByPayrollChannel(totalPayrollAmount.current.slice(startIndex, endIndex));
	}

	return (
		<>
			<MainDashboardPresentational
				{...{ pageLoading }}
				isDataLoading={isDataLoading}
				payrollHistory={payrollHistory}
				employeeCount={employeeCount}
				employeePaidByPayroll={employeePaidByPayrollChannel}
				employeePaidByMonth={employeePaidByMonth}
				cardRequest={cardRequest}
				payoutTiming={payoutTiming}
				currentTimeCutOff={currentTimeCutOff}
				onCardHistorySlideChange={handleCardHistorySlideChange}
				onPayrollAmountSlideChange={handlePayrollAmountSlideChange}
				totalPayrollHistory={totalPayrollHistory.current}
				totalCardRequest={totalCardRequest.current}
				totalEmployeePaidOff={totalEmployeePaidOff.current}
				currentActiveSlide={currentActiveSlide}
				currentCardOrderActiveSlide={currentCardOrderActiveSlide}
				currentPayrollAmountActiveSlide={currentPayrollAmountActiveSlide}
				payrollTotalData={totalPayrollHistory.current.length}
				cardOrderTotalData={totalCardRequest.current.length}
				currentUser={currentUser}
				approveReqCount={approveReqCount}
				isPayrollHistoryLoading={isPayrollHistoryLoading}
				isCardHistoryLoading={isCardHistoryLoading}
				isEmployeePaidLoading={isEmployeePaidLoading}
				isPayrollAmountLoading={isPayrollAmountLoading}
				isEmployeeCountLoading={isEmployeeCountLoading}
			/>
		</>
	);
};
const mapStateToProps = (state) => {
	return {
		currentUser: SelectorsApp.currentUser(state),
		corporateIds: SelectorsApp.corporateIds(state),
		corporateLoading: SelectorsApp.corporateLoading(state),
		user: state.oidc.user,
	};
};

export default connect(mapStateToProps, null)(MainDashboard);
